import * as React from 'react'

const AppLoader = () => {
  return (
<div className="d-flex justify-content-center">
  <div className="spinner-border  text-primary" role="status">
    <span className="visually-hidden">Loading...</span>
  </div>
</div>
  )
}
export default AppLoader
